import { useQuery } from '@tanstack/react-query'
import { getRecentOfferPurchases, type RecentOfferPurchaseType } from 'api/order'

// Two minutes (1/30 of an hour), matching svc-order's public Cache-Control window.
// Keep this short so the social-proof timestamp reflects recent purchase activity.
const RECENT_OFFER_PURCHASES_STALE_TIME_MS = 2 * 60 * 1000

export function useRecentOfferPurchases(
  offerId: string,
  offerType: RecentOfferPurchaseType,
  enabled = true,
) {
  const { data } = useQuery({
    queryKey: ['recent-offer-purchases', offerId, offerType],
    queryFn: () => getRecentOfferPurchases(offerId, offerType),
    enabled: enabled && !!offerId,
    staleTime: RECENT_OFFER_PURCHASES_STALE_TIME_MS,
    // The endpoint applies a per-offer rate limit, so do not multiply a failed request.
    retry: false,
    select: (purchases): Array<App.OfferRecentPurchase> => purchases.map(purchase => ({
      country: purchase.region.trim().toUpperCase(),
      purchasedAt: purchase.purchasedAt,
      isLuxPlusPurchase: purchase.isLuxPlusPurchase === true,
    })),
  })

  return data
}
